var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5376 0.47928C20.1542 1.11832 20.1542 2.15441 19.5376 2.79345L11.1165 11.5207C10.4999 12.1598 9.50019 12.1598 8.88358 11.5207L0.462524 2.79345C-0.154093 2.15441 -0.154093 1.11832 0.462524 0.479281C1.07914 -0.159759 2.07888 -0.159759 2.69549 0.479281L10.0001 8.04947L17.3046 0.47928C17.9212 -0.15976 18.921 -0.15976 19.5376 0.47928Z",
    fill: "#9A989C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand-more.01c8dd85d24f041b9c3d01a9762a738c.svg";
export { ForwardRef as ReactComponent };